import { clone, omit } from "lodash";
import axiosConnect from "../../../utils/axiosConnect";

/** Patient create/update body uses root fields only; never send `additional` (names use `first_name` / `middle_name` / `last_name`). */
function omitAdditionalForApi(patientData) {
  return omit(clone(patientData), "additional");
}
var addEditPatient = function addEditPatient(patientData, isEditMode, sourceId) {
  var url = "/patients/".concat(sourceId, "/create/");
  if (isEditMode && patientData !== null && patientData !== void 0 && patientData.patient_uid) {
    url = "/patients/".concat(patientData === null || patientData === void 0 ? void 0 : patientData.patient_uid, "/");
  }
  var payload = omitAdditionalForApi(patientData);
  return axiosConnect.post(url, payload).then(function (res) {
    return res;
  })["catch"](function (err) {
    console.error(err);
  });
};
export default addEditPatient;